import { PartnerSpecialization } from 'clickNgo/entities/partner/models/specialization'
import { IForm } from 'core-components/classes/models/IForm'

export const mapPartnerSpecializationFromRawData = (data: IForm): PartnerSpecialization => ({
  partnerId: data.PartnerID,
  moduleName: data.ModuleName,
  name: data.Name,
  isCompleted: Boolean(data.IsCompleted),
  isMember: Boolean(data.IsMember),
  htmlSnippet: data.HtmlSnippet,
  sortOrder: data.SortOrder,
  groupName: data.GroupName,
  groupOrder: data.GroupOrder,
})
